import { Time } from '../types'
import { isTimeNaN, isTimeDefined, getMinuteTotal } from '.'

interface Errors {
  start: string[]
  end: string[]
  duration: string[]
}

interface ValidationResult {
  errors: Errors
  isInvalid: boolean
}

export const validate = (
  startTime: Time,
  endTime: Time,
  duration: Time,
): ValidationResult => {
  const errors: Errors = {
    start: [],
    end: [],
    duration: [],
  }

  if (isTimeNaN(startTime)) errors.start.push('Invalid time')
  if (isTimeNaN(endTime)) errors.end.push('Invalid time')
  if (isTimeNaN(duration)) errors.duration.push('Invalid time')

  if (isTimeDefined(startTime) && isTimeDefined(endTime)) {
    const endTimeInMinutes = getMinuteTotal(endTime)
    const startTimeInMinutes = getMinuteTotal(startTime)

    if (endTimeInMinutes <= startTimeInMinutes)
      errors.end.push('End must be later than start')
  }

  return {
    errors,
    isInvalid: Object.values(errors).some((e: string[]) => e.length > 0),
  }
}
